/**
 * Theme default values - Single Source of Truth
 * Following DRY principle: all default theme values defined once
 */

export const THEME_DEFAULTS = {
  PRIMARY_COLOUR: '#ecbf16',
  PRIMARY_TEXT_COLOUR: '#000000',
  SECONDARY_COLOUR: '#1a1a1a',
  APP_NAME: 'Macc Beer Fest',
  LOGO_PATH: '',
  BACKGROUND_PATH: '',
} as const;

/**
 * CSS custom property names - prevents typos and ensures consistency
 */
export const CSS_VARS = {
  PRIMARY_COLOUR: '--primary-colour',
  PRIMARY_TEXT_COLOUR: '--primary-text-colour',
  SECONDARY_COLOUR: '--secondary-colour',
  PRIMARY_COLOUR_LIGHT: '--primary-colour-light',
  PRIMARY_COLOUR_DARK: '--primary-colour-dark',
  PRIMARY_COLOUR_ALPHA_30: '--primary-colour-alpha-30',
  PRIMARY_COLOUR_ALPHA_20: '--primary-colour-alpha-20',
} as const;
